module.exports = __webpack_public_path__ + "media/images/emblems/Dalpe-coat_of_arms-4589efaca5489f86151027d8a22bd0a0.svg";